<template>
  <div id="app">
    <Navbar></Navbar>
    <BlogCardContainer></BlogCardContainer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import BlogCardContainer from './components/BlogCardContainer.vue'


export default {
  name: 'App',
  components: {
    Navbar,
    BlogCardContainer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
